<template>
  <el-dialog :title="$t('alarmHistory.notificationPersion')"
             :visible="true"
             :close-on-click-modal="false"
             size="small"
             class="notify-container"
             :before-close="handleClose">
    <el-radio-group v-model="notifyName"
                    @change="handleChange"
                    class="radio-space">
      <el-radio-button v-for="(item,index) in notifyArray"
                       :key="index"
                       :label="item.value">{{item.label}}</el-radio-button>
    </el-radio-group>
    <div v-if="notifyName === 'secindLabel' && this.tips"
         class="show-tips">{{$t('alarmHistory.showGroupInfo')}}
      <a href="https://uc.jdcloud.com/account/contacts"
         target="_blank">{{$t('alarmHistory.countManagement')}}</a>
      {{$t('alarmHistory.toOperation')}}</div>
    <el-table v-loading="isLoading" :data="tableData"
              max-height="300"
              style="width: 100%">
        <el-table-column v-if="index"
                        fixed
                        type="index"
                        width="250"
                        :label="$t('alarmHistory.index')">
        </el-table-column>
      <div v-if="hasRequest"> 
        <el-table-column v-for="item in this[`${notifyName}`]"
                       :key="item.value"
                       :prop="item.value"
                       :formatter="maybeEmpty"
                       :label="item.label">
                       <template slot-scope="scope"> <span>{{scope.row}}</span> </template>
      </el-table-column>
      </div>
      <div v-else>
          <el-table-column v-for="item in this[`${notifyName}`]"
                        :key="item.value"
                        :prop="item.value"
                        :formatter="maybeEmpty"
                        :label="item.label">
        </el-table-column>
      </div>
    </el-table>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleClose">{{$t('alarmHistory.close')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      show: false,
      notifyName: this.notifyArray[0].value,
      tableData: [],
      obj: {},
      isLoading: true
    };
  },
  mounted () {
    if (!this.hasRequest) {
      this.tableData = this.firstArray;
      this.isLoading = false;
    }
  },
  created() {
    if (!this.hasRequest) return;
    this.$api.getAlarmHistoryNotice({id: this.id})
    .then((res) => {
      if (res.errno === 10000) {
        this.tableData = res.data.phone;
        this.obj = res.data;
        return;
      }
      return Promise.reject();
    })
    .catch(() => {
      this.tableData = [];
      this.obj = {};
    })
    .finally(() => {
      this.isLoading = false;
    })
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    hasRequest: {
      type: Boolean,
      default: () =>false
    },
    notifyArray: { // 通知对象radio数组
      type: Array,
      default: () => null
    },
    firstLabel: { // 第一个table需要展示内容
      type: Array,
      default: () => null
    },
    id: {
      type: Number | null,
      default: null
    },
    secindLabel: { // 第二个table需要展示内容
      type: Array,
      default: () => null
    },
    firstArray: { // 第一个table数据
      type: Array,
      default: () => null
    },
    secindArray: { // 第二个table数据
      type: Array,
      default: () => null
    },
    // 是否需要序号 默认不需要
    index: {
      type: Boolean,
      default: false
    },
    // 是否需要提示
    tips: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    handleClose () {
      this.show = false;
      this.$emit('update:visible', false);
    },
    maybeEmpty (row, column) {
      const arr = row[column.property];
      if (arr === '') {
        return '--';
      } if (arr === '0' || arr === 0) {
        return 0;
      }
      return arr;
    },
    handleChange (name) {
      if (name === 'firstLabel') {
        this.tableData = !this.hasRequest ? this.firstArray : this.obj.phone;
      }
      if (name === 'secindLabel') {
        this.tableData = !this.hasRequest ? this.secindArray :  this.obj.email;
      }
    }
  }
};

</script>
<style lang="scss" scoped>
.notify-container {
  .radio-space {
    margin-bottom: 10px;
  }
  .show-tips {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alarm/opt/Notification.vue